import { Record } from 'immutable';

const SessionScheduleRecord = Record({
  id: undefined,
  period: undefined,
});

class SessionSchedule extends SessionScheduleRecord { }

export default SessionSchedule;



// WEBPACK FOOTER //
// ./containers/Group/GroupSummary/SessionSchedule/model.js